// src/stores/auth.ts
import { defineStore } from "pinia";
import { TOKEN_KEY } from "@/auth/token";
import localforage from "localforage";

export const useAuthStore = defineStore("auth", {
    state: () => ({
        token: (localStorage.getItem(TOKEN_KEY) as string | null) || null,
        socialRegistrationToken: sessionStorage.getItem("social_registration_token") || null,
        socialRegistrationProvider: sessionStorage.getItem("social_registration_provider") || null,
        socialRegistrationContext: sessionStorage.getItem("social_registration_context") || null,
    }),
    getters: {
        isAuthenticated: (s) => !!s.token,
    },
    actions: {
        setToken(t: string) {
            this.token = t;
            localStorage.setItem(TOKEN_KEY, t);
        },
        setSocialRegistration(token: string, provider?: string | null) {
            this.socialRegistrationToken = token;
            this.socialRegistrationProvider = provider || null;
            sessionStorage.setItem("social_registration_token", token);
            if (provider) sessionStorage.setItem("social_registration_provider", provider);
            else sessionStorage.removeItem("social_registration_provider");
        },
        setSocialRegistrationContext(provider: string, context: Record<string, string>) {
            this.socialRegistrationProvider = provider;
            this.socialRegistrationContext = JSON.stringify(context);
            sessionStorage.setItem("social_registration_provider", provider);
            sessionStorage.setItem("social_registration_context", this.socialRegistrationContext);
        },
        getSocialRegistrationContext(): Record<string, string> | null {
            if (!this.socialRegistrationContext) return null;
            try {
                return JSON.parse(this.socialRegistrationContext);
            } catch {
                return null;
            }
        },
        clearSocialRegistration() {
            this.socialRegistrationToken = null;
            this.socialRegistrationProvider = null;
            this.socialRegistrationContext = null;
            sessionStorage.removeItem("social_registration_token");
            sessionStorage.removeItem("social_registration_provider");
            sessionStorage.removeItem("social_registration_context");
        },
        async clear() {
            this.token = null;
            this.clearSocialRegistration();

            localStorage.removeItem(TOKEN_KEY);
            localStorage.removeItem("access_token");
            localStorage.removeItem("theme");
            document.documentElement.classList.remove("dark");

            try {
                await localforage.removeItem("access_token");
            } catch { }
        },
    },
});
